import { createSingleRaceFeed } from '../stores.js';
import { renderSvelteComponent, findElementByIdInShadowDom } from './render.js';
import HpEmbed from '../components/HpEmbed.svelte';
import { sharedRaceFile } from '../shared-races.js';

/**
 * @param {string} raceId - The race id, e.g. 'CA-6123'
 * @param {string} [raceName] - Optional. Only 'measure' does anything: it draws the race as
 *   Yes/No when the feed doesn't already mark it as a measure. Propositions and
 *   measures in the feed are detected on their own, so leave this out for them.
 * @param {string} [source] - The race's source: 'ap' or 'lavote' for L.A. races.
 *   Leave it out for races in scripts/shared-races.js: they load from the source
 *   their `use` picks (the box is still found by the AP id); others default to AP.
 */
export async function mountHpEmbed(raceId, raceName = '', source) {
  const element = findElementByIdInShadowDom(`hp-${raceId}`);
  if (!element) return;

  const crosswalk = window.CROSSWALK.assets.img;
  const [id, raceSource] = source ? [raceId, source] : sharedRaceFile(raceId);
  const race = await createSingleRaceFeed(id, raceSource);

  renderSvelteComponent(
    HpEmbed,
    /** @type {HTMLElement} */ (element.querySelector('.contest')),
    { race, crosswalk, name: raceName }
  );
}
